<div class="list-container">
    <table class="table">
        <thead>
            <tr class="table-header">
                <th id="BankAccount" class="table-header-title text-start">{{'myProfile.bankAccount' | translate}}</th>
                <th id="Bank" class="table-header-title text-center">{{'myProfile.bank' | translate}}</th>
                <th id="Currency" class="table-header-title text-center">{{'myProfile.currency' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let bankAccount of bankAccounts">
                <tr class="row-container">
                    <td HJSuppress id="BankAccount" class="column-content table-main-td text-start">
                        {{bankAccount.accountNumber}}
                    </td>
                    <td HJSuppress id="Bank" class="column-content text-center">
                        {{bankAccount.bankName}}
                    </td>
                    <td HJSuppress id="Currency" class="column-content text-center">
                        {{bankAccount.currency}}
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>